import formatAmount from 'helpers/formatAmount'
import { Customer, Invoice } from 'types'
import getCustomerName from 'helpers/getCustomerName'
import { TableProps } from 'antd'
import getCustomerAddress from 'helpers/getCustomerAddress'

export const tableColumns: TableProps<Invoice>['columns'] = [
  {
    key: 'id',
    title: 'Id',
    dataIndex: 'id',
  },
  {
    key: 'customer',
    title: 'Customer',
    dataIndex: 'customer',
    render: (customer: Customer) => getCustomerName(customer) ?? '-',
  },
  {
    key: 'address',
    title: 'Address',
    dataIndex: 'customer',
    render: (customer: Customer) => {
      return getCustomerAddress(customer) ?? '-'
    },
  },
  {
    key: 'total',
    title: 'Total',
    dataIndex: 'total',
    render: (total: string) => formatAmount(Number(total)) ?? '-',
  },
  {
    key: 'tax',
    title: 'Tax',
    dataIndex: 'tax',
    render: (tax: string) => formatAmount(Number(tax)) ?? '-',
  },
  {
    key: 'finalized',
    title: 'Finalized',
    dataIndex: 'finalized',
    render: (finalized: boolean) => (finalized ? 'Yes' : 'No'),
  },
  {
    key: 'paid',
    title: 'Paid',
    dataIndex: 'paid',
    render: (paid: boolean) => (paid ? 'Yes' : 'No'),
  },
  {
    key: 'date',
    title: 'Date',
    dataIndex: 'date',
    render: (date: string) => date ?? '-',
  },
  {
    key: 'deadline',
    title: 'Deadline',
    dataIndex: 'deadline',
    render: (deadline: string) => deadline ?? '-',
  },
]
